import React from 'react';
export function SiteFooter() {
  return <footer className="bg-navy px-4 py-10 sm:px-6" data-id="element-93" data-mp="1dqrohw3lfk7t">
      <div className="mx-auto w-full max-w-[42rem] lg:max-w-3xl" data-id="element-94" data-mp="3r7pxdxcwyf51">
        <p className="text-[0.85rem] font-semibold text-white" data-id="element-95" data-mp="3ralu5id0yxrw">
          OT Clinical Toolkit™
        </p>
        <p className="mt-2.5 text-[0.74rem] leading-relaxed text-white/55" data-id="element-96" data-mp="3hig3qd2f8oet">
          A digital professional resource system for Occupational Therapists. It
          supports professional organization and clinical reasoning and does not
          replace individualized assessment, clinical judgment, training or
          applicable standards of practice.
        </p>
        <p className="mt-4 text-[0.7rem] text-white/35" data-id="element-97" data-mp="33ix5qd3bqtg8">
          © {new Date().getFullYear()} OT Clinical Toolkit™. All rights
          reserved.
        </p>
      </div>
    </footer>;
}